import { useMutation as t } from "@tanstack/react-query";
import { logoutMutation as r } from "../reactQuery.es.js";
const i = (o) => t({
  ...o,
  ...r
});
export {
  i as useLogout
};
